import { FC } from 'react';

import CreatorAvatar from '../CreatorAvatar';
import type { SanityLandingHero } from '@lib/sanity/types';

const AVATAR_SIZE = 56;

type EndorsementProps = {
  hero: SanityLandingHero;
};

/**
 * Creator endorsement: the highest-leverage trust block on the affiliate
 * variant, in the creator's own words. Rendered only when there is a quote.
 */
const Endorsement: FC<EndorsementProps> = ({ hero }) => {
  const { creatorName, creatorHandle, creatorQuote, creatorPortrait } = hero;

  if (!creatorQuote) return null;

  return (
    <section className="border-b border-landing-hairline bg-white px-6 py-10">
      <div className="mx-auto flex w-full max-w-md items-start gap-4 md:max-w-2xl">
        <CreatorAvatar
          name={creatorName}
          portrait={creatorPortrait}
          renderedSize={AVATAR_SIZE}
          ringWidth={2.5}
        />

        <div>
          <p className="text-lg font-bold leading-snug text-landing-ink">
            <span className="text-[color:var(--accent)]">“</span>
            {creatorQuote}
            <span className="text-[color:var(--accent)]">”</span>
          </p>
          {(creatorName || creatorHandle) && (
            <p className="mt-2 text-sm font-semibold text-landing-slate">
              <span className="text-landing-ink">{creatorName}</span>
              {creatorHandle ? ` · ${creatorHandle}` : ''}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Endorsement;
